import React, { Component } from 'react';

import classNames from 'classnames';
import debounce from 'lodash.debounce';
import PropTypes from 'prop-types';

import { Button } from 'wanderu-components';
import { localize } from 'wanderu-i18n';
import {
    ChevronLeft,
    ChevronRight,
} from 'wanderu-icons';

import GridItem from './GridItem/GridItem';

import styles from './PriceGrid.scss';

class PriceGrid extends Component {
    static propTypes = {
        activeDate: PropTypes.string,
        className: PropTypes.string,
        featuredDates: PropTypes.object.isRequired,
        locationData: PropTypes.shape({
            arrival: PropTypes.shape({
                name: PropTypes.string,
                placeId: PropTypes.string,
            }),
            departure: PropTypes.shape({
                name: PropTypes.string,
                placeId: PropTypes.string,
            }),
        }),
        onDateSelect: PropTypes.func,
    };

    static defaultProps = {
        activeDate: '',
        className: '',
        locationData: {},
        onDateSelect() {},
    };

    constructor(props) {
        super(props);

        this.state = {
            enableLeftScroll: false,
            enableRightScroll: true,
        };

        this._container = React.createRef();
        this._debouncedDetectScroll = debounce(this._detectScroll, 100);
    }

    _detectScroll = () => {
        const {
            scrollLeft,
            scrollWidth,
            clientWidth,
        } = this._container.current;

        this.setState({
            enableLeftScroll: scrollLeft > 0,
            enableRightScroll: scrollLeft !== scrollWidth - clientWidth,
        });
    }

    _scrollContainer = (distance) => {
        const {
            scrollBy,
        } = this._container.current;

        if (!scrollBy) {
            return;
        }

        this._container.current.scrollBy({
            left: distance,
            behavior: 'smooth',
        });
    }

    _scrollLeft = () => {
        const {
            scrollWidth,
        } = this._container.current;

        this._scrollContainer(-1 * scrollWidth);
    }

    _scrollRight = () => {
        const {
            scrollWidth,
        } = this._container.current;

        this._scrollContainer(scrollWidth);
    }

    _onClick = (date) => {
        this.props.onDateSelect(date);
    }

    render() {
        const {
            activeDate,
            className,
            featuredDates,
            locationData,
        } = this.props;
        const {
            enableLeftScroll,
            enableRightScroll,
        } = this.state;

        const showDateOnly = !Object.keys(locationData).length;

        return (
            <div
                className={classNames(
                    className,
                    styles.container,
                )}
            >
                <Button
                    aria-controls="price-grid"
                    className={classNames(
                        styles.chevronContainer,
                        { [styles.priceRibbon]: !showDateOnly },
                    )}
                    disabled={!enableLeftScroll}
                    onClick={this._scrollLeft}
                    unstyled
                >
                    <ChevronLeft />
                </Button>
                <ol
                    className={classNames(
                        styles.priceGrid,
                        { [styles.withBorders]: !showDateOnly },
                    )}
                    id="price-grid"
                    onScroll={this._debouncedDetectScroll}
                    ref={this._container}
                >
                    {Object.entries(featuredDates).map(([date, price], index) => (
                        <GridItem
                            date={date}
                            index={index}
                            key={date}
                            locationData={locationData}
                            onClick={this._onClick}
                            price={price}
                            selected={activeDate === date}
                            showDateOnly={showDateOnly}
                        />
                    ))}
                </ol>
                <Button
                    aria-controls="price-grid"
                    className={classNames(
                        styles.chevronContainer,
                        { [styles.priceRibbon]: !showDateOnly },
                    )}
                    disabled={!enableRightScroll}
                    onClick={this._scrollRight}
                    unstyled
                >
                    <ChevronRight />
                </Button>
            </div>
        );
    }
}

export { PriceGrid };
export default localize(PriceGrid);
